// Resolves API + Cognito endpoints at runtime (window.RUNTIME_CONFIG from
// /config.js), with build-time VITE_* fallbacks and localhost defaults.

export interface DeploymentConfig {
  apiUrl: string;
  cognitoDomain: string;
  cognitoUiUrl: string;
  clientId: string;
}

export function getDeploymentConfig(): DeploymentConfig {
  const hostname = window.location.hostname;
  const isLocalhost = hostname === "localhost" || hostname === "127.0.0.1";
  const runtime = window.RUNTIME_CONFIG ?? {};
  const env = import.meta.env;

  // Vite proxies /play-api to the real API in dev (vite.config.ts).
  const defaultApiUrl = isLocalhost
    ? "/play-api"
    : "https://api.kast-dev.net/play-api";

  return {
    apiUrl: runtime.VITE_PLAY_API_BASE_URL || env.VITE_PLAY_API_BASE_URL || defaultApiUrl,
    cognitoDomain: runtime.VITE_COGNITO_DOMAIN || env.VITE_COGNITO_DOMAIN || "",
    cognitoUiUrl:
      runtime.VITE_COGNITO_UI_URL || env.VITE_COGNITO_UI_URL || "https://login.kast-dev.net",
    clientId: runtime.VITE_COGNITO_CLIENT_ID || env.VITE_COGNITO_CLIENT_ID || "",
  };
}
